var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#cacedd;}.cls-1{opacity:0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hide") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 3,
    width: 41,
    height: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.5,3.5c-7.69,0-14.67,4.21-19.82,11a1.61,1.61,0,0,0,0,1.91C5.83,23.29,12.81,27.5,20.5,27.5s14.67-4.21,19.82-11a1.61,1.61,0,0,0,0-1.91C35.17,7.71,28.19,3.5,20.5,3.5ZM21.05,24a8.47,8.47,0,1,1,7.9-7.9A8.48,8.48,0,0,1,21.05,24Zm-.25-3.9a4.56,4.56,0,1,1,4.25-4.26A4.57,4.57,0,0,1,20.8,20.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.42,30.91h0a1,1,0,0,1-.58-1.38L26.12.63A1.13,1.13,0,0,1,27.58.09h0a1,1,0,0,1,.58,1.38L14.88,30.37A1.13,1.13,0,0,1,13.42,30.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.498a5a2f5cdf6803687dbd3490b4567a.svg";
export { ForwardRef as ReactComponent };